import config from 'react-global-configuration'
config.set({
    ga_tag: "",
    ga_debug: false,
    base:"https://telecubesapis.bngrenew.com/apn",
    elastic_base_url:"https://serviceusagesv1.bngrenew.com/publish",
    domain : "btc",
    // he : "/he",
    // requestOTP: "/requestOTP",
    // activate: "/activate",
    checkSub: "/checkSub",
    // unsubscribe : '/unsubscribe',
    unsubscribe : '/unsub_other',
    userPacks : '/userPacks',
    appConfig : '/config' , 
    subscribe:"/subscribe",
    sendOtp:"/requestOTP",
    pinSubmit:"/activate",
    headers: {
        'Reqfrom': 'web',
        'Username': 'web',
        'Language' : localStorage.getItem("lang") || 'en',
        //'Language': reactLocalStorage.get("lang")?reactLocalStorage.get("lang"):'en',
        'Servicefor':'https://zainkw.cubegames.live'
    }
})

export const getHeaders = () => {
    const headers = { ...config.get("headers") };  // Get existing headers
    headers["w_req_url"] = window.location.href;
    headers["camp"] = localStorage.getItem("camp") || sessionStorage.getItem("camp") || "";
    headers["rcid"] = localStorage.getItem("carcidmp") || sessionStorage.getItem("rcid") || "";
    headers["mtype"] = localStorage.getItem("mtype") || "nonhe";  /* only non he flow */
    headers["blocked"] = localStorage.getItem("blocked") || 0;     /* no blocklist */
    headers["breason"] = localStorage.getItem("breason") || "";
    return headers;    //return updated headers
};


export default config